// extracted by mini-css-extract-plugin
export default {"tasks-page":"TasksPage_tasks-page__ilIHg"};